import React, { useEffect, useState } from 'react';

import type { CallTemplate } from 'bundles/connect/types';
import { Col, Dropdown, Form, Modal, Row } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import { createCallTemplate, updateCallTemplate } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from '../../helpers/display_toast';

type CallTemplateModalProps = {
  show: boolean;
  setTemplates: React.Dispatch<React.SetStateAction<CallTemplate[]>>;
  setShow: (show: boolean) => void;
  template?: CallTemplate
}

export default function CallTemplateModal({ show, setShow, setTemplates, template }: CallTemplateModalProps) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const params = {
      connect_liquid_template: {
        title: title,
        body: body,
        template_type: 'call',
      }
    };

    if (template) {
      updateCallTemplate(params, template.id)
        .then((response) => {
          setTemplates((prevTemplates: CallTemplate[]) => {
            return prevTemplates.map((template: CallTemplate) => {
              if (template.id === response.id) {
                return response;
              }
              return template;
            });
          });
          displayToast('Call Template successfully updated', 'success');
          setShow(false);
        });
    } else {
      createCallTemplate(params)
        .then((response) => {
          setTemplates((prevTemplates: CallTemplate[]) => {
            return [...prevTemplates, response];
          });
          displayToast('Call Template successfully created', 'success');
          setShow(false);
        });
    }
  };

  const handleMergeFields = (e: any) => {
    if (!e.target.dataset.value) return;

    e.preventDefault();
    setBody((body || '') + e.target.dataset.value);
  };

  useEffect(() => {
    if (show) {
      setTitle(template?.title || '');
      setBody(template?.body || '');
    }
  }, [show]);

  return (
    <Modal show={show} size="lg" onHide={() => setShow(false)}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title>{template ? 'Update' : 'New'} Call Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label>Title <small className="text-danger">{'(required)'}</small></Form.Label>
            <Form.Control
              required
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Body <small className="text-danger">{'(required)'}</small></Form.Label>
            <Form.Control
              as="textarea"
              id="connect_liquid_template_body"
              required
              rows={3}
              value={body}
              onChange={e => setBody(e.target.value)}
            />
          </Form.Group>
          <Row className="align-items-center">
            <Col className="col">
              <Dropdown id="merge-field-select">
                <Dropdown.Toggle id="dropdown-merge-field" variant="shaded-secondary">
                  Add Merge Field
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item data-value="{{my_name}}" href="#" onClick={handleMergeFields}>
                    My Name
                  </Dropdown.Item>
                  <Dropdown.Item data-value="{{my_email}}" href="#" onClick={handleMergeFields}>
                    My Email
                  </Dropdown.Item>
                  <Dropdown.Item data-value="{{contact_full_name}}" href="#" onClick={handleMergeFields}>
                    Contact Full Name
                  </Dropdown.Item>
                  <Dropdown.Item data-value="{{contact_first_name}}" href="#" onClick={handleMergeFields}>
                    Contact First Name
                  </Dropdown.Item>
                  <Dropdown.Item data-value="{{contact_last_name}}" href="#" onClick={handleMergeFields}>
                    Contact Last Name
                  </Dropdown.Item>
                  <Dropdown.Item data-value="{{property_name}}" href="#" onClick={handleMergeFields}>
                    Property Name
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs="auto">
              <Button label="Cancel" variant="ghost" onClick={() => setShow(false)} />
            </Col>
            <Col xs="auto">
              <Button label={template ? 'Update Template' : 'Create Template'} type="submit" />
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
